import { render } from "./ShowerIcon.vue?vue&type=template&id=5fd4d3a7"
import script from "./ShowerIcon.vue?vue&type=script&lang=js"
export * from "./ShowerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__